<template>
    <div class="flex flex-col">
        <form-header
            :title="formdata.veranstaltung.name"
        />
        <div class="flex justify-center mb-4 bg-primary flex-grow flex-col-reverse md:flex-row">
            <div class="fixed top-0 left-0 right-0 bottom-0 bg-black opacity-50 flex space-x-2 items-center justify-center"
            v-if="!formdata.veranstaltung.name">
                <div class="w-5 h-5 animate-pulse bg-white rounded-full"></div>
                <div class="w-5 h-5 animate-pulse bg-white rounded-full"></div>
                <div class="w-5 h-5 animate-pulse bg-white rounded-full"></div>
            </div>
            <div class="fixed top-0 left-0 right-0 bottom-0 bg-black opacity-75 flex space-x-2 items-center justify-center"
            v-if="formdata.veranstaltung.name && !formdata.veranstaltung.anmeldungOffen">
                <div class="bg-white rounded-md border-2 border-black opacity-100 p-8">Die Anmeldung für diese Veranstaltung ist geschlossen.</div>
            </div>
            <div v-if="formdata.veranstaltung.name">
                <div class="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
                    <ValidationObserver ref="form">
                        <form-section v-if="formdata.veranstaltung.infotextHeader" v-html="formdata.veranstaltung.infotextHeader">

                        </form-section>
                        <form-section title="Angaben zur Person">
                            <drop-down
                            v-if="formdata.veranstaltung.anredeAbfragen"
                            :values="[
                                { id: 1, name: 'Herr' },
                                { id: 2, name: 'Frau' },
                            ]"
                            v-model="teilnahme.anrede"
                            label="Anrede"
                            rules="required"
                            columns="3"
                        ></drop-down>
                        <div v-if="formdata.veranstaltung.anredeAbfragen" class="col-span-3"></div>

                            <text-input
                                rules="required"
                                columns="3"
                                label="Vorname"
                                v-model="teilnahme.vorname"
                            />
                            <text-input
                                rules="required"
                                columns="3"
                                label="Nachname"
                                v-model="teilnahme.nachname"
                            />
                            <text-input
                                v-model="teilnahme.geburtsdatum"
                                label="Geburtsdatum"
                                placeholder="z.B. 14.03.2008"
                                columns="2"
                                rules="required|date"
                            />
                            <drop-down
                            v-if="formdata.veranstaltung.geschlechtAbfragen"
                            :values="[
                                { id: 865250000, name: 'weiblich' },
                                { id: 865250001, name: 'männlich' },
                                { id: 865250002, name: 'divers' },
                            ]"
                            v-model="teilnahme.geschlecht"
                            label="Geschlecht"
                            rules="required"
                            columns="3"
                        ></drop-down>
                        <drop-down
                                v-if="!formdata.veranstaltung.blockAusbildungAnzeigen && formdata.veranstaltung.musikschuleAbfragen"
                                rules="required"
                                :values="formdata.musikschulen"
                                label="Musikschule"
                                v-model="teilnahme.musikschuleId" 
                            />
                            <drop-down
                                v-if="formdata.veranstaltung.instrumentAngeben"
                                :values="formdata.instrumente"
                                label="Instrument"
                                v-model="teilnahme.instrumentId"
                            />
                            <text-input v-if="formdata.veranstaltung.zusatzinstrumenteMoeglich"
                                v-model="teilnahme.zusatzinstrumente" 
                                label="Zusatzinstrumente / Nebeninstrumente"
                                columns="6"
                            />
                            <file-upload v-if="formdata.veranstaltung.dateiuploadAnzeigen"
                                label="Upload"
                                :maxSize="maxFileSize"
                                @size-exceeded="onSizeExceeded"
                                @metadata="onUpload($event)"
                                @fileloaded="onUploadLoad($event)"
                            />
                        </form-section>
                        <form-section title="Kontaktinformation">
                            <text-input
                                rules="required|email"
                                columns="3"
                                label="E-Mail"
                                v-model="teilnahme.email"
                            />
                            <text-input
                                rules="required"
                                columns="3"
                                label="Telefonnummer"
                                v-model="teilnahme.telefonnummer"
                            />
                        </form-section>
                        <form-section v-if="formdata.veranstaltung.adresseingabe" title="Anschrift">                            
                            <text-input
                                label="Postleitzahl"
                                v-model="teilnahme.plz"
                                rules="required|numeric|length:4"
                                columns="2"
                            />
                            <text-input
                                label="Ort"
                                v-model="teilnahme.ort"
                                rules="required"
                                columns="4"
                            />
                            <text-input
                                label="Straße"
                                v-model="teilnahme.strasse"
                                rules="required"
                                columns="4"
                            />
                            <text-input
                                label="Hausnummer, Stiege"
                                v-model="teilnahme.hausnummerStiege"
                                rules="required"
                                columns="2"
                            />
                        </form-section>
                        <form-section v-if="formdata.veranstaltung.blockAusbildungAnzeigen" title="Ausbildung">
                            <drop-down v-if="formdata.anmeldungUeberOptions.length > 0"                                
                                label="Anmeldung über:"
                                rules="required"
                                :values="formdata.anmeldungUeberOptions"
                                v-model="formbehaviour.anmeldungUeber"
                                @input="onAnmeldungUeberChanged()"
                            />
                            <text-input v-else
                                rules=""
                                columns="6"
                                label="Musikschule"
                                v-model="teilnahme.musikschuleText"
                            />
                            <drop-down
                                v-if="formbehaviour.anmeldungUeber === '0'"
                                rules="required"
                                :values="formdata.musikschulen"
                                label="Musikschule"
                                v-model="teilnahme.musikschuleId"
                            />
                            <text-input
                                v-if="formbehaviour.anmeldungUeber === '1'"
                                label="Name der Institution"
                                rules="required"
                                v-model="teilnahme.andereInstitution"
                            />
                            <text-input
                                rules=""
                                columns="6"
                                label="Lehrperson"
                                v-model="teilnahme.lehrperson"
                            />
                        </form-section>
                        <form-section title="Musikalische/Künstlerische Erfahrung" v-if="formdata.veranstaltung.musikalischeErfahrungAngeben || formdata.veranstaltung.letzteWerkeAngeben">
                            <text-input v-if="formdata.veranstaltung.musikalischeErfahrungAngeben"
                                label="Künstlerische Erfahrung"
                                v-model="teilnahme.musikalischeErfahrung"
                                columns="6"
                            />
                            <text-input v-if="formdata.veranstaltung.musikalischeErfahrungAngeben"
                                label="Lernjahr/Ausbildungsstufe"
                                rules="required"
                                v-model="teilnahme.lernjahrOderAusbildungsstufe"
                                columns="6"
                            />
                            <text-input v-if="formdata.veranstaltung.musikalischeErfahrungAngeben"
                                label="Schule/Beruf"
                                v-model="teilnahme.schuleOderBeruf"
                                columns="6"
                            />
                            <text-input v-if="formdata.veranstaltung.letzteWerkeAngeben"
                                label="Zuletzt gespielte(s) Werk(e) (KomponistIn & Titel)"
                                rules="required"
                                v-model="teilnahme.letzteWerke"
                                columns="6"
                            />
                        </form-section>
                        <form-section title="Erziehungsberechtigte:r" v-if="formdata.veranstaltung.erziehungsberechtigteAngeben && getAge(teilnahme.geburtsdatum) < 18">
                            <text-input
                                label="Name eines/einer Erziehungsberechtigten"
                                v-model="teilnahme.ebname"
                                :rules="getAge(teilnahme.geburtsdatum) < 18 ? 'required' : ''"
                                columns="6"
                            />                            
                            <text-input
                                label="Adresse"
                                v-model="teilnahme.ebadresse"
                                :rules="getAge(teilnahme.geburtsdatum) < 18 ? 'required' : ''"
                                columns="5"
                            />
                            <check-box
                                label="Adresse von Musiker übernehmen"
                                @input="takeAdressFromMusikerChanged"
                            />
                            <text-input
                                label="Telefonnummer (Erziehungsberechtigte:r)"
                                v-model="teilnahme.ebtelefon"
                                :rules="getAge(teilnahme.geburtsdatum) < 18 ? 'required' : ''"
                                columns="3"
                            />
                            <text-input
                                label="E-Mail (Erziehungsberechtigte:r)"
                                v-model="teilnahme.ebemail"
                                :rules="getAge(teilnahme.geburtsdatum) < 18 ? 'required|email' : ''"
                                columns="3"
                            />
                        </form-section>
                        <form-section title="Kleidungsgrößen" v-if="formdata.veranstaltung.schuhgroesseAbfragen || formdata.veranstaltung.tShirtGroesseAbfragen">
                            <text-input
                                v-if="formdata.veranstaltung.schuhgroesseAbfragen"
                                label="Schuhgröße"
                                v-model="teilnahme.schuhgroesse"
                                :rules="required"
                                columns="3"
                            />
                            <text-input
                                v-if="formdata.veranstaltung.tShirtGroesseAbfragen"
                                label="T-Shirt-Größe"
                                v-model="teilnahme.tShirtGroesse"
                                :rules="required"
                                columns="3"
                            />
                        </form-section>
                        <form-section title="Video Link" v-if="formdata.veranstaltung.videolinkAngeben">
                            <text-input
                                label="Video URL (Bitte bei schicks.digital oder anderem Anbieter hochladen und hier den Link eingeben)"
                                v-model="teilnahme.videoUrl"
                                rules="required"
                                columns="6"
                            />
                        </form-section>
                        <form-section title="Sonstiges" v-if="formdata.veranstaltung.anmerkungenAngeben">
                            <text-area-input v-if="formdata.veranstaltung.anmerkungenAngeben"
                                :label="formdata.veranstaltung.infotextAnmerkungen ? formdata.veranstaltung.infotextAnmerkungen : 'Anmerkungen'"
                                v-model="teilnahme.anmerkungen"
                                columns="6"
                            />
                        </form-section>
                        <form-section title="Datenschutz">
                            <text-block
                                :content="
                                    textbausteinfuer(
                                        'allgemein.informationspflicht'
                                    ).contentPlain
                                "
                                class="col-span-6"
                            />
                            <text-block v-if="formdata.veranstaltung.medienverwaltungAbfragen"
                                class="col-span-6"
                                :content="
                                    textbausteinfuer(
                                        'allgemein.bildundton'
                                    ).contentPlain
                                "
                            />
                            <radio-button-list v-if="formdata.veranstaltung.medienverwaltungAbfragen"
                                title="Bild und Ton Zustimmung"
                                rules="required"
                                v-model="teilnahme.medienverwaltung"
                                :options="{
                                    'Ich stimme zu': 1,
                                    'Ich stimme nicht zu': 0,
                                }"
                            />
                        </form-section>
                        <div
                            class="mt-6 bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6"
                        >
                            <div class="sm:grid sm:grid-cols-3 sm:gap-6">
                                <div class="sm:col-span-1">&nbsp;</div>
                                <span class="inline-flex rounded-md shadow-sm">
                                    <button
                                        @click="sendTeilnahme()"
                                        type="button"
                                        class="inline-flex items-center px-32 md:px-48 sm:px-8 py-2 border border-transparent text-base leading-6 font-medium rounded-md text-white bg-green-600 hover:bg-green-500 focus:outline-none focus:border-indigo-700 focus:shadow-outline-green active:bg-green-700 transition ease-in-out duration-150"
                                    >
                                        Anmeldung absenden
                                    </button>
                                </span>
                            </div>
                        </div>
                    </ValidationObserver>
                    <success-modal
                        text="Sie können das Fenster nun schließen."
                        v-if="formbehaviour.successful"
                    />
                    <sending-modal v-if="formbehaviour.sending" />
                    <error-modal
                        v-if="formbehaviour.showErrorModal"
                        @clickedoutside="formbehaviour.showErrorModal = false"
                        :text="formbehaviour.errorText"
                    />
                </div>
            </div>
            <div>
                <div
                    class="flex space-y-2 flex-col bg-white w-full md:w-80 p-5 pb-12 mt-6 mr-6 rounded-lg shadow"
                    v-if="formdata.veranstaltung.name"
                >
                    <div >
                        <p><strong>Veranstaltung</strong></p>
                        {{ formdata.veranstaltung.name }}
                    </div>
                    <div v-if="formdata.veranstaltung.infotext">
                        <p><strong>Info</strong></p>
                        <span v-html="formdata.veranstaltung.infotext"></span>
                    </div>
                    <div v-if="formdata.veranstaltung.veranstaltungsort">
                        <p><strong>Veranstaltungsort</strong></p>
                        {{ formdata.veranstaltung.veranstaltungsort }} 
                    </div>  
                    
                    <div>
                        <div v-if="formdata.veranstaltung.beginn"><p><strong>Beginn</strong></p>{{
                            new Date(
                                formdata.veranstaltung.beginn
                            ).toLocaleString()
                        }}</div>
                        <div v-if="formdata.veranstaltung.ende"><p><strong>Ende</strong></p>{{
                            new Date(
                                formdata.veranstaltung.ende
                            ).toLocaleString()
                        }}</div>
                       
                    </div>
                    <div v-if="formdata.veranstaltung.anmeldungVon">
                        <div><strong>Anmeldefrist</strong></div>
                        <span>{{
                            new Date(
                                formdata.veranstaltung.anmeldungVon
                            ).toLocaleString()
                        }}</span>
                        <span v-if="formdata.veranstaltung.anmeldungBis"> bis {{
                            new Date(
                                formdata.veranstaltung.anmeldungBis
                            ).toLocaleString()
                        }}</span>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormHeader from '@/components/forms/FormHeader.vue'
import FormSection from '@/components/forms/FormSection.vue'
import TextInput from '@/components/inputs/TextInput.vue'
import TextAreaInput from '@/components/inputs/TextAreaInput.vue'
import DropDown from '@/components/inputs/DropDown.vue'
import SuccessModal from '@/components/modals/SuccessModal.vue'
import SendingModal from '@/components/modals/SendingModal.vue'
import ErrorModal from '@/components/modals/ErrorModal.vue'
import CheckBox from '@/components/inputs/CheckBox.vue'
import TextBlock from '@/components/inputs/TextBlock.vue'
import FileUpload from '@/components/inputs/FileUpload.vue'
import RadioButtonList from '@/components/inputs/RadioButtonList.vue'

export default {
    name: 'Form',
    inject: ['service'],
    props: {
        id: {
            id: String,
            required: true,
        },
    },
    data: function () {
        return {
            formdata: {
                veranstaltung: {},
                instrumente: [],
                musikschulen: [],
                textbausteine: [],
                zustimmung: false,
                anmeldungUeberOptions: []
            },
            formbehaviour: {
                sending: false,
                successful: false,
                showErrorModal: false,
                errorText: "",
                adresseMusikerUebernehmen: false,
            },
            teilnahme: {
                anrede: null,
                geschlecht: null,
                veranstaltungId: null,
                vorname: null,
                nachname: null,
                email: null,
                instrumentId: null,
                telefonnummer: null,
                geburtsdatum: null,
                musikschuleText: null,
                musikschuleId: null,
                lehrperson: null,
                andereInstitution: null,
                plz: null,
                ort: null,
                strasse: null,
                hausnummerStiege: null,
                zusatzinstrumente: null,
                upload: {
                    subject: "Upload - Teilnahme",
                    filename: null,
                    mimeType: null,
                    body: null,
                },
                ebname: null,
                ebadresse: null,
                ebtelefon: null,
                ebemail: null,
                musikalischeErfahrung: null,
                lernjahrOderAusbildungsstufe: null,
                schuleOderBeruf: null,
                letzteWerke: null,
                videoUrl: null,
                anmerkungen: null,
                medienverwaltung: 0,
                tShirtGroesse: null,
                schuhgroesse: null
            },
            maxFileSize: 5
        }
    },
    computed: {
      loaded() {
       return this.formdata.veranstaltung;
      }
    },
    methods: {
        async fetchVeranstaltung() {
            const { data } = await this.service.veranstaltung.byKey(this.id);
            this.formdata.veranstaltung = data;

            if (data) {
                await this.fetchMusikschulen();

                if (this.formdata.veranstaltung.dateiuploadAnzeigen === true) {
                    this.teilnahme.upload.subject = `Upload - Teilnahme ${this.formdata.veranstaltung.name}`;
                }

                if (this.formdata.veranstaltung.anmeldungUeberMusikschule === true) {
                    this.formdata.anmeldungUeberOptions.push({ name: 'Musikschule', id: '0' });
                }
                if (this.formdata.veranstaltung.anmeldungUeberAndereInstitution === true) {
                    this.formdata.anmeldungUeberOptions.push({ name: 'Andere Institution', id: '1' });
                }
                if (this.formdata.veranstaltung.anmeldungUeberPrivatlehrer === true) {
                    this.formdata.anmeldungUeberOptions.push({ name: 'Privatlehrer', id: '2' });
                }

                if (!this.formdata.veranstaltung.textblockFormularIdentifier) {
                    this.formdata.veranstaltung.textblockFormularIdentifier = 'allgemein';
                }
            }
        },
        async fetchInstrumente() {
            const { data } = await this.service.veranstaltung.faecher(this.id);
            this.formdata.instrumente = data;
            this.formdata.instrumente.sort((a,b) => a.name > b.name ? 1 : -1);            
        },
        async fetchMusikschulen() {
            const { data } = await this.service.musikschule.powerAppsAlle();
            this.formdata.musikschulen = data;
            this.formdata.musikschulen.sort((a, b) =>
                a.kurzbezeichnung > b.kurzbezeichnung ? 1 : -1
            );
        },
        async sendTeilnahme() {
            this.formbehaviour.sending = true;
            var validation = await this.$refs.form.validate()

            if (!validation) {
                window.scrollTo(0, 0)
                this.formbehaviour.sending = false;
                return
            }

            this.teilnahme.veranstaltungId = this.formdata.veranstaltung.id;

            await this.service.veranstaltung.teilnahmeErstellen(this.teilnahme);
            this.formbehaviour.sending = false;
            this.formbehaviour.successful = true;
        },
        async fetchTextbausteine() {
            const { data } = await this.service.formular
                .get(
                    this.formdata.veranstaltung.textblockFormularIdentifier
                )
                .textbloeckePowerApps()

            this.formdata.textbausteine = data
        },
        textbausteinfuer(id) {
            const found = this.formdata.textbausteine.find(
                (element) => element.identifier == id
            )

            if (!found) return id

            return found
        },
        onUpload(file) {
            this.teilnahme.upload.mimeType = file.type
            this.teilnahme.upload.filename = file.name
        },
        onUploadLoad(dataUri) {
            this.teilnahme.upload.body = dataUri
        },
        onSizeExceeded(size) {
            alert(`Die Datei mit ${size} MB überschreitet die maximale Dateigröße von ${this.maxFileSize} MB.`)
        },
        getAge(dateString) {
            if (!dateString)
                return null;

            var pattern = /(\d{1,2})\.(\d{1,2})\.(\d{4})/;
            var birthDate = new Date(dateString.replace(pattern, '$3-$2-$1'));

            var today = new Date();
            var age = today.getFullYear() - birthDate.getFullYear();
            var m = today.getMonth() - birthDate.getMonth();

            if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
                age--;
            }

            return age;
        },
        takeAdressFromMusikerChanged() {
            this.formbehaviour.adresseMusikerUebernehmen = !this.formbehaviour.adresseMusikerUebernehmen;

            if (this.formbehaviour.adresseMusikerUebernehmen) {
                this.teilnahme.ebadresse = `${
                    this.teilnahme.strasse ? this.teilnahme.strasse : ''
                } ${this.teilnahme.hausnummerStiege ? this.teilnahme.hausnummerStiege + ',' : ''
                } ${this.teilnahme.plz ? this.teilnahme.plz : ''
                } ${this.teilnahme.ort ? this.teilnahme.ort : ''
                }`;
            } 
            else {
                this.teilnahme.ebadresse = '';
            }
        },
        onAnmeldungUeberChanged() {
            this.teilnahme.musikschuleText = "";
            this.teilnahme.andereInstitution = "";
            this.teilnahme.musikschuleId = null;
        }
    },
    async created() {
        try {
            await this.fetchVeranstaltung(this.id);
            await this.fetchInstrumente();
            await this.fetchTextbausteine();
        } 
        catch {
            this.formbehaviour.errorText = 'Die Informationen für die Anmeldung konnten nicht geladen werden.';
            this.formbehaviour.showErrorModal = true;
        }  
    },
    components: {
        FormHeader,
        FormSection,
        TextInput,
        TextAreaInput,
        DropDown,
        SuccessModal,
        SendingModal,
        ErrorModal,
        CheckBox,
        TextBlock,
        FileUpload,
        RadioButtonList
    },
}
</script>
